/**
 * The occasion a § 18 Mitteilung came into being on (TM-9636 / #1632).
 *
 * ⚠ **Two occasions and no third.** The §125-Vertrag requires the Kassen to
 * learn of an Auftragsverhältnis's **beginning** and **end**. A newer version of
 * the terms is neither: it changes the text between practice and Therame, not
 * the fact of who bills for the practice and from when.
 */
export var Paragraf18MitteilungVariant;
(function (Paragraf18MitteilungVariant) {
    /** From when Therame bills — generated as soon as the Beauftragung leaves *entwurf*. */
    Paragraf18MitteilungVariant["START"] = "START";
    /** Until when Therame bills — generated as soon as an end is set. */
    Paragraf18MitteilungVariant["END"] = "END";
})(Paragraf18MitteilungVariant || (Paragraf18MitteilungVariant = {}));
/**
 * What the occasion is called in a file name and in a row (TM-9636 / #1632).
 *
 * ⚠ **One map and not a ternary per call site.** The occasion is turned into
 * text in five places — the document's display number, the file name on
 * download, the row in the foldout, the sheet's heading. Five ternaries would
 * drift apart at the first third occasion, and `Record<…>` forces every new
 * value to fetch an answer here.
 */
export const PARAGRAF_18_MITTEILUNG_SLUG = {
    [Paragraf18MitteilungVariant.START]: 'beginn',
    [Paragraf18MitteilungVariant.END]: 'ende',
};
/** The occasion as a practice reads it. */
export const PARAGRAF_18_MITTEILUNG_LABEL = {
    [Paragraf18MitteilungVariant.START]: 'Beginn',
    [Paragraf18MitteilungVariant.END]: 'Ende',
};
//# sourceMappingURL=paragraf-18-mitteilung-variant.enum.js.map